import React from "react";
import { Check, Loader2 } from "lucide-react";
import type { RazmerCellSaveStatus } from "../hooks/useRNRazmerAutosave";

interface Props {
  status?: RazmerCellSaveStatus;
}

/**
 * Autosave feedback inside a Размерување cell — same visual as PackingVersionCell
 * (spinner while saving, short ✓ after success). Absolutely positioned at the cell's
 * right edge so the fixed-width Кол. раз./Отпад/Растур columns never widen.
 */
const RNRazmerCellSaveMark: React.FC<Props> = ({ status }) => {
  if (!status) return null;
  return (
    <span className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2 inline-flex items-center">
      {status === "saving"
        ? <Loader2 className="w-3.5 h-3.5 animate-spin text-blue-500" />
        : <Check className="w-3.5 h-3.5 text-green-600" />}
    </span>
  );
};

export default RNRazmerCellSaveMark;
